module.exports = __webpack_public_path__ + "img/bs.3d1823e1.svg";